import type { CommonResponse, EmptyResponse } from '@/types/responseModel';
import { Request } from '@/utils/request';

interface IUserSettingsRes {
  preferredLanguage?: string;
  userLanguage?: string;
}

export interface LanguageItem {
  englishName: string;
  languageCode: string;
  nativeName: string;
}
export function fetchUserSettings() {
  return Request<CommonResponse<IUserSettingsRes> | EmptyResponse>({
    url: '/rest/os/user/settings/get',
    method: 'get'
  });
}

export function updateUserSettings(data: IUserSettingsRes) {
  return Request<CommonResponse<void>>({
    url: '/rest/os/user/settings/save',
    method: 'post',
    data
  });
}

export function fetchLanguageList() {
  return Request<CommonResponse<LanguageItem[]>>({
    url: '/rest/os/user/settings/meta/languages',
    method: 'get'
  });
}
